import { forwardRef, type Ref, type SVGProps } from "react";
const IconWaterOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.071 2a1.574 1.574 0 0 1 1.572 1.568v1.568a1.574 1.574 0 0 1-1.572 1.568h-2.357v1.568h.393c.934 0 1.738.655 1.925 1.567h2.004c1.085 0 1.964.879 1.964 1.96v3.92c0 1.083-.88 1.96-1.964 1.96h-9.822v.142a2.348 2.348 0 0 1-.785 4.563h-3.564l.283.25.002.002.007.006.025.023.088.08a17 17 0 0 1 1.245 1.274c.34.387.697.836.972 1.292.262.434.515.974.515 1.52 0 1.798-1.55 3.169-3.352 3.169-1.8 0-3.352-1.371-3.352-3.17 0-.544.252-1.085.515-1.519a9.5 9.5 0 0 1 .971-1.293 17 17 0 0 1 1.245-1.274l.09-.08.024-.022.006-.006.003-.003.283-.25H7.356a2.348 2.348 0 0 1-.785-4.563v-2.493a5.5 5.5 0 0 1 5.5-5.488h1.61a1.96 1.96 0 0 1 1.926-1.567H16V6.704h-2.357a1.575 1.575 0 0 1-1.572-1.568V3.568A1.574 1.574 0 0 1 13.643 2zM10.65 24.227c-.215.213-.477.481-.736.776-.31.354-.604.73-.816 1.08-.226.374-.3.623-.3.747.001.876.78 1.673 1.853 1.673s1.852-.797 1.852-1.673c0-.124-.073-.373-.299-.746a8 8 0 0 0-.816-1.08 15 15 0 0 0-.738-.777m-3.293-4.98a.787.787 0 0 0-.698 1.183.79.79 0 0 0 .593.381l7.178.004a.785.785 0 0 0 0-1.568zM16 9.84a.79.79 0 0 0-.786.785v.784H12.07a3.926 3.926 0 0 0-3.928 3.92v2.351h5.5v-.783a.787.787 0 0 1 .786-.784h11v-4.704H21.5v-1.176a.39.39 0 0 0-.393-.393zm1.571-1.567h1.572V6.704H17.57zm-3.928-3.136h9.428V3.568h-9.428z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconWaterOutlineSVG);
ForwardRef.displayName = "IconWaterOutline";
export { ForwardRef as IconWaterOutline };
